<div class="register-container">
  <h2 class="register-title">Registrarme</h2>
</div>

<!-- Inline message container -->
<div *ngIf="message" class="form-message" [ngClass]="{
  'form-message--success': messageType === 'success',
  'form-message--error': messageType === 'error',
  'form-message--info': messageType === 'info'
}">
  {{ message }}
  </div>

<form class="register-form" [formGroup]="form" (ngSubmit)="register()" novalidate>
  <div class="form-group">
    <label for="userGroup" class="form-label">Tipo de usuario
      <span class="tooltip" title="Usuario general o Administrador de hotel.">ℹ️</span>
    </label>
    <select id="userGroup" class="form-input" formControlName="userGroup" required>
      <option value="user">Turista</option>
      <option value="admin-hotel">Empresario de turismo</option>
    </select>
  </div>

  <div class="form-group">
    <label for="email" class="form-label">Correo electrónico
      <span class="tooltip" title="Usa un correo válido para confirmar el registro.">ℹ️</span>
    </label>
    <input type="email" id="email" class="form-input"
           formControlName="email" placeholder="name@gmail.com" autocomplete="email" />
    <div class="validation-messages" *ngIf="shouldShowError('email')">
      <small class="error">{{ getError('email') }}</small>
    </div>
  </div>
  
  <div class="form-group">
    <label for="name" class="form-label">Primer nombre
      <span class="tooltip" title="Solo letras, espacios y guiones.">ℹ️</span>
    </label>
    <input type="text" id="name" class="form-input"
           formControlName="given_name" placeholder="Tu primer nombre" autocomplete="given-name" />
    <div class="validation-messages" *ngIf="shouldShowError('given_name')">
      <small class="error">{{ getError('given_name') }}</small>
    </div>
  </div>
  
  <div class="form-group">
    <label for="lastName" class="form-label">Apellidos
      <span class="tooltip" title="Solo letras, espacios y guiones.">ℹ️</span>
    </label>
    <input type="text" id="lastName" class="form-input"
           formControlName="family_name" placeholder="Tus apellidos" autocomplete="family-name" />
    <div class="validation-messages" *ngIf="shouldShowError('family_name')">
      <small class="error">{{ getError('family_name') }}</small>
    </div>
  </div>

  <div class="form-group">
    <label for="documentType" class="form-label">Tipo de documento
      <span class="tooltip" title="Selecciona el tipo de documento.">ℹ️</span>
    </label>
    <select id="documentType" class="form-input" formControlName="document_type" required>
      <option value="CC">Cédula de ciudadanía</option>
      <option value="CE">Cédula de extranjería</option>
      <option value="PA">Pasaporte</option>
      <option value="PPT">Permiso de permanencia temporal</option>
    </select>
    <div class="validation-messages" *ngIf="shouldShowError('document_type')">
      <small class="error">{{ getError('document_type') }}</small>
    </div>
  </div>
    
  <div class="form-group">
    <label for="numberDocument" class="form-label">Número de documento
      <span class="tooltip" title="Solo dígitos; 6 a 20 caracteres.">ℹ️</span>
    </label>
        <input type="text" id="numberDocument" class="form-input"
          formControlName="document_number" placeholder="1234567890" inputmode="numeric" autocomplete="off" />
    <div class="validation-messages" *ngIf="shouldShowError('document_number')">
      <small class="error">{{ getError('document_number') }}</small>
    </div>
  </div>

  <div class="form-group" *ngIf="form.get('userGroup')?.value === 'admin-hotel'">
    <label for="rnt" class="form-label">Registro Nacional de Turismo (RNT)
      <span class="tooltip" title="Obligatorio para Admin Hotel. 4 a 10 dígitos.">ℹ️</span>
    </label>
        <input type="text" id="rnt" class="form-input"
          formControlName="rnt" placeholder="123456" inputmode="numeric" autocomplete="off" />
    <div class="validation-messages" *ngIf="shouldShowError('rnt')">
      <small class="error">{{ getError('rnt') }}</small>
    </div>
  </div>
  
  <div class="form-group">
    <label for="password" class="form-label">Contraseña
      <span class="tooltip" title="Mín 8; mayúscula, minúscula, número y símbolo.">ℹ️</span>
    </label>
    <div class="password-input-wrapper">
      <input [type]="showPassword ? 'text' : 'password'" id="password" class="form-input"
             formControlName="password" minlength="8"
             autocomplete="new-password" placeholder="••••••••" />
      <button type="button" class="eye-button" (click)="togglePasswordVisibility('password')" aria-label="Mostrar/ocultar contraseña">
        <fa-icon [icon]="showPassword ? faEyeSlash : faEye"></fa-icon>
      </button>
    </div>
    <div class="validation-messages" *ngIf="shouldShowError('password')">
      <small class="error">{{ getError('password') }}</small>
    </div>
  </div>
  
  <div class="form-group">
    <label for="repeat-password" class="form-label">Confirma contraseña
      <span class="tooltip" title="Repite la contraseña.">ℹ️</span>
    </label>
    <div class="password-input-wrapper">
      <input [type]="showConfirmPassword ? 'text' : 'password'" id="repeat-password" class="form-input"
             formControlName="confirmPass" autocomplete="new-password" placeholder="••••••••" />
      <button type="button" class="eye-button" (click)="togglePasswordVisibility('confirm')" aria-label="Mostrar/ocultar confirmación de contraseña">
        <fa-icon [icon]="showConfirmPassword ? faEyeSlash : faEye"></fa-icon>
      </button>
    </div>
    <div class="validation-messages" *ngIf="shouldShowError('confirmPass') || form.hasError('passwordMismatch')">
      <small class="error">{{ getError('confirmPass') }}</small>
    </div>
  </div>
  
  <div class="form-checkbox-group">
    <div class="checkbox-container">
      <input id="terms" type="checkbox" class="form-checkbox" formControlName="termsAccepted" />
    </div>
    <label for="terms" class="checkbox-label">Acepto los <a href="#" class="terms-link">términos y condiciones</a></label>
    <div class="validation-messages" *ngIf="shouldShowError('termsAccepted')">
      <small class="error">Debes aceptar los términos.</small>
    </div>
  </div>
  
  <button type="submit" class="submit-button"
          [disabled]="form.invalid || isLoading"
          [class.loading]="isLoading">
    <span *ngIf="!isLoading">Registrarme</span>
    <div class="spinner" *ngIf="isLoading"></div>
  </button>
</form>